import * as $ from 'jquery';
import Popper from 'popper.js';
import Tether from 'tether';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'

window.Tether = Tether;
window.Popper = Popper;
window.jQuery = window.$ = $;